"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isParentValue = _interopRequireDefault(require("./isParentValue"));

var _updateChild = _interopRequireDefault(require("./updateChild"));

var _updateChildKeys = _interopRequireDefault(require("./updateChildKeys"));

var _set = _interopRequireDefault(require("unmutable/lib/set"));

var _pipeIf = _interopRequireDefault(require("unmutable/lib/util/pipeIf"));

var _pipe = _interopRequireDefault(require("unmutable/lib/util/pipe"));

var _default = function _default(value) {
  return (0, _pipe.default)((0, _set.default)('value', value), (0, _pipeIf.default)(function () {
    return (0, _isParentValue.default)(value);
  }, (0, _updateChild.default)(), (0, _updateChildKeys.default)()));
};

exports.default = _default;